import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-alert-dialog',
    templateUrl: './alert-dialog.component.html',
    styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent implements OnInit {

    title: string;
    message: string;
    confirmText = 'OK';
    confirmColor = 'primary';

    constructor(public dialogRef: MatDialogRef<AlertDialogComponent>) {
    }

    ngOnInit() {
    }

    onConfirm() {
        this.dialogRef.close();
    }
}
